import React, { Component } from 'react';
import validator from 'validator';
import { Row, Col, Form, Card, Input, Icon } from 'antd';

export default class EmailIdentificationAndChange extends Component {
    state = {
        emailFormProps1: {
            hasFeedback: false,
            required: true,
            help: '',
            validateStatus: '',
            label: 'New Email Address'
        },
        emailFormProps2: {
            hasFeedback: false,
            required: true,
            help: '',
            validateStatus: '',
            label: 'Verify New Email Address'
        }
    }

    constructor(props) { super(props); }

    updateFormProps = (value, name, props, valid) => {
        let secondary = '', primaryProps = null, secondaryProps = null;

        const
        primary = value,
        emailMatch = (
            <div>
                <div style={{ position: 'absolute', right: '22px', top: '13px' }}>
                    <Icon type='check-circle' style={{ color: 'rgb(82, 196, 26)' }} />
                </div>
                <div style={{ marginBottom: '12px' }}></div>
            </div>
        );

        switch(name) {
            case 'emailAddress1':
                secondary = this.props.state.passwordReset.emailAddress2.email;
                primaryProps = props.emailFormProps1;
                secondaryProps = props.emailFormProps2;
                break;
            case 'emailAddress2':
                secondary = this.props.state.passwordReset.emailAddress1.email;
                primaryProps = props.emailFormProps2;
                secondaryProps = props.emailFormProps1;
                break;
        }

        if(primary.length > 0) {
            if(primary === secondary) {
                primaryProps.help = emailMatch;
                primaryProps.validateStatus = 'success';
                secondaryProps.help = emailMatch;
                secondaryProps.validateStatus = 'success';

                if(!valid) {
                    switch(name) {
                        case 'emailAddress1':
                            primaryProps.help = 'Not a valid email';
                            primaryProps.validateStatus = 'error';
                            secondaryProps.help = '';
                            secondaryProps.validateStatus = '';
                            break;
                        case 'emailAddress2':
                            primaryProps.help = '';
                            primaryProps.validateStatus = '';
                            secondaryProps.help = 'Not a valid email';
                            secondaryProps.validateStatus = 'error';
                            break;
                    }
                }
            } else {
                primaryProps.help = 'Email addresses must match';
                primaryProps.validateStatus = 'warning';
            }
        } else {
            primaryProps.help = '';
            primaryProps.validateStatus = '';
            if(secondary.length === 0) {
                secondaryProps.help = '';
                secondaryProps.validateStatus = '';
            } else {
                secondaryProps.help = 'Email addresses must match';
                secondaryProps.validateStatus = 'warning';
            }
        }

        this.setState({...this.state,
            emailFormProps1: primaryProps.label === props.emailFormProps1.label ? primaryProps : secondaryProps,
            emailFormProps2: primaryProps.label === props.emailFormProps2.label ? primaryProps : secondaryProps
        });
    }

    render() {
        const
        { emailFormProps1, emailFormProps2 } = this.state,
        { state, services } = this.props,
        { emailId, emailAddress1, emailAddress2 } = state.passwordReset,
        formProps = { emailFormProps1, emailFormProps2 };

        return (
            <div>
                <div style={{
                    boxShadow: 'rgb(184, 184, 184) 0px 0px 20px',
                    borderRadius: '10px',
                    borderStyle: 'solid',
                    borderColor: 'rgb(200, 200, 200)',
                    borderWidth: '1px'
                }}>
                    <Card style={{
                        borderRadius: '10px',
                        borderStyle: 'solid',
                        borderColor: 'rgb(255, 255, 255)',
                        borderWidth: '1px'
                    }}>
                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '10px' }}>
                            <Col>
                                <Form.Item label='FTSP User ID' required={true} style={{ width: '300px' }}>
                                    <Input
                                        size='small'
                                        placeholder='FTSP User ID'
                                        prefix={(<Icon type='user' />)}
                                        onChange={e => services.updateResetField(e.target.name, e.target.value)}
                                        value={emailId}
                                        name='emailId'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '10px' }}>
                            <Col>
                                <Form.Item {...emailFormProps1} style={{ width: '300px' }}>
                                    <Input
                                        size='small'
                                        placeholder='New Email Address'
                                        prefix={(<Icon type='mail' />)}
                                        onChange={e => {
                                            let { name, value } = e.target;
                                            this.updateFormProps(value, name, {...formProps}, validator.isEmail(value));
                                            services.updateResetField(name, value);
                                        }}
                                        value={emailAddress1.email}
                                        name='emailAddress1'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row type='flex' justify='space-around' align='middle'>
                            <Col>
                                <Form.Item {...emailFormProps2} style={{ width: '300px' }}>
                                    <Input
                                        size='small'
                                        placeholder='Verify new Email Address'
                                        prefix={(<Icon type='mail' />)}
                                        onChange={e => {
                                            let { name, value } = e.target;
                                            this.updateFormProps(value, name, {...formProps}, validator.isEmail(value));
                                            services.updateResetField(name, value);
                                        }}
                                        value={emailAddress2.email}
                                        name='emailAddress2'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </div>
        );
    }
}
